import React, { useEffect, useState } from 'react';
import { fetchClientBreakdown, IClientBreakdown } from '../../api';
import { TopEnvironmentsCard, TopCountriesCard } from './cards/EnvironmentCard';
import { useWebsite } from '../../hooks/useWebsite';
import { useDateRange } from '../../hooks/useDateRange';

const EnvironmentWrapper = () => {
  const { websiteId } = useWebsite();
  const { from, to, timezone } = useDateRange();
  const [data, setData] = useState<IClientBreakdown | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const result: IClientBreakdown = await fetchClientBreakdown(websiteId, {from, to, timezone});
      setData(result);
    } catch (err) {
      console.error('Error loading client data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchData() }, [from, to]);

  if (isLoading) return <div>Loading...</div>;
  if (!data) return <div>No data available.</div>;

  return (
    <div className="row mt-5">
      <div className="col-md-6 d-flex">
        <TopEnvironmentsCard
          values={data}
          className="card flex-fill d-flex flex-column"
        />
      </div>
      <div className="col-md-6 d-flex">
        <TopCountriesCard
          items={data?.country || []}
          className="card flex-fill d-flex flex-column"
        />
      </div>
    </div>
  );
};

export default EnvironmentWrapper;
